import React, { useState, useEffect, useRef } from 'react';
import Threads from '../effects/Threads/Threads'; // ✅ Your background component
import './TechStack.css';

const TechStack = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [hoveredTech, setHoveredTech] = useState(null);
  const sectionRef = useRef(null);

  const technologies = [
    { name: 'Adobe Photoshop', icon: '/images/Adobe Photoshop.svg', color: '#31A8FF', category: 'Design' },
    { name: 'After Effects', icon: '/images/After Effects.svg', color: '#9999FF', category: 'Design' },
    { name: 'AWS', icon: '/images/AWS.svg', color: '#FF9900', category: 'Cloud' },
    { name: 'C', icon: '/images/C.svg', color: '#A8B9CC', category: 'Programming' },
    { name: 'CSS3', icon: '/images/CSS3.svg', color: '#1572B6', category: 'Frontend' },
    { name: 'Docker', icon: '/images/Docker.svg', color: '#2496ED', category: 'DevOps' },
    { name: 'Firebase', icon: '/images/Firebase.svg', color: '#FFCA28', category: 'Backend' },
    { name: 'Git', icon: '/images/Git.svg', color: '#F05032', category: 'Version Control' },
    { name: 'GitHub', icon: '/images/GitHub.svg', color: '#181717', category: 'Version Control' },
    { name: 'GitLab', icon: '/images/GitLab.svg', color: '#FCA121', category: 'Version Control' },
    { name: 'HTML5', icon: '/images/HTML5.svg', color: '#E34F26', category: 'Frontend' },
    { name: 'Java', icon: '/images/Java.svg', color: '#007396', category: 'Programming' },
    { name: 'JavaScript', icon: '/images/JavaScript.svg', color: '#F7DF1E', category: 'Frontend' },
    { name: 'Kubernetes', icon: '/images/Kubernetes.svg', color: '#326CE5', category: 'DevOps' },
    { name: 'MongoDB', icon: '/images/MongoDB.svg', color: '#47A248', category: 'Database' },
    { name: 'MySQL', icon: '/images/MySQL.svg', color: '#4479A1', category: 'Database' },
    { name: 'Node.js', icon: '/images/Node.js.svg', color: '#339933', category: 'Backend' },
    { name: 'Python', icon: '/images/Python.svg', color: '#3776AB', category: 'Programming' },
    { name: 'React', icon: '/images/React.svg', color: '#61DAFB', category: 'Frontend' },
    { name: 'Tailwind CSS', icon: '/images/Tailwind CSS.svg', color: '#38B2AC', category: 'Frontend' }
  ];

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => setIsVisible(entry.isIntersecting),
      { threshold: 0.1 }
    );

    const currentRef = sectionRef.current;
    if (currentRef) observer.observe(currentRef);

    return () => {
      if (currentRef) observer.unobserve(currentRef);
    };
  }, []);

  const handleTechHover = (techName) => setHoveredTech(techName);
  const handleTechLeave = () => setHoveredTech(null);

  const handleImageError = (tech, e) => {
    const parent = e.target.parentNode;
    parent.innerHTML = `
      <div class="icon-fallback" style="background-color: ${tech.color}">
        ${tech.name.charAt(0)}
      </div>
    `;
  };

  return (
    <div id="techstack" className='bg-wave' style={{ position: 'relative', width: '100%', overflow: 'hidden' }}>
      {/* Background Threads */}
      {/* <div style={{
        width: '100%',
        height: '100%',
        position: 'absolute',
        top: 0,
        left: 0,
        zIndex: 0,
        pointerEvents: 'none'
      }}>
        <Threads amplitude={1} distance={0} enableMouseInteraction={true} />
      </div> */}

      {/* Foreground Tech Stack */}
      <section 
        ref={sectionRef}
        className={`tech-stack ${isVisible ? 'visible' : ''}`} 
        id="tech-stack"
        style={{ position: 'relative', zIndex: 1 }}
      >
        <div className="container">
          <h2 className="section-title">My Tech Stack</h2>
          <p className="section-subtitle">
            Technologies I work with to create amazing digital experiences
          </p>
          
          <div className="tech-grid">
            {technologies.map((tech, index) => (
              <div 
                key={tech.name}
                className={`tech-card ${hoveredTech === tech.name ? 'hovered' : ''}`}
                style={{ '--animation-order': index }}
                onMouseEnter={() => handleTechHover(tech.name)}
                onMouseLeave={handleTechLeave}
                onFocus={() => handleTechHover(tech.name)}
                onBlur={handleTechLeave}
                tabIndex={0}
                aria-label={tech.name}
              >
                <div className="tech-icon-container">
                  <img 
                    src={process.env.PUBLIC_URL + tech.icon}
                    alt={tech.name}
                    className="icon-img"
                    onError={(e) => handleImageError(tech, e)}
                    loading="lazy"
                    width="60"
                    height="60"
                  />
                </div>
                <h3 className="tech-name">{tech.name}</h3>
                <div className="tech-category" style={{ color: tech.color }}>
                  {tech.category}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default TechStack;
